import React from 'react'
import Errors from '../errors'

const ErrorsSv = () => {
    return <Errors languageCode="sv" />
}

export default ErrorsSv
